import Header from './components/Header/Header'
import LinkContainer from './components/LinkContainer/LinkContainer'
import './App.css';

function App() {
  return (
    <div className="App">
<Header />
<LinkContainer />
    </div>
  );
}

export default App;
